import React from 'react';
import CardBaseInput from './CardBaseInput';
import utils from '../../helpers/payment-utils';

class CardExpiryInput extends CardBaseInput {
  constructor(props) {
    super(props);
    this.cardExpiry = undefined;
    this.handleChangeExpiryDate = this.handleChangeExpiryDate.bind(this);
    this.handleKeyPressExpiryDate = this.handleKeyPressExpiryDate.bind(this);
  }

  handleChangeExpiryDate(props = {}) {
    return e => {
      const { errorMessages = {}, onChange = () => {} } = props;
      const formattedExpiryDate = utils.formatter.formatExpiry(e) || '';
      const value = formattedExpiryDate.split(' / ');
      onChange && onChange(value);
      this.setInputTouched(false);

      const expiryDateField = this.cardExpiry;
      expiryDateField.value = utils.formatter.formatExpiry(e);

      const error = utils.validator.getExpiryDateError(expiryDateField.value, { errorMessages });
      if (error) {
        onChange && onChange(['', '']);
      }

      this.setError(error);
    };
  }

  handleKeyPressExpiryDate(props = {}) {
    return e => {
      const formattedExpiryDate = e.target.value || '';
      const expiryDate = formattedExpiryDate.replace(' / ', '');
      const value = formattedExpiryDate.split(' / ');

      const { onKeyPress = () => {} } = props;
      onKeyPress && onKeyPress(value);

      if (e.key !== 'Enter') {
        if (!utils.validator.isNumeric(e)) {
          e.preventDefault();
        }

        if (expiryDate.length >= 4) {
          e.preventDefault();
        }
      }
    };
  }

  render() {
    const props = {
      'aria-label': 'Expiry date in format MM YY',
      autoComplete: 'cc-exp',
      id: 'expiryDate',
      name: 'expiryDate',
      placeholder: 'MM/YY',
      type: 'tel',
      ref: ref => this.cardExpiry = ref,
      ...this.props,
      onBlur: this.handleBlurInput(this.props),
      onChange: this.handleChangeExpiryDate(this.props),
      onKeyPress: this.handleKeyPressExpiryDate(this.props),
    };

    const { touched, error } = this.state;

    return (
      <div className="input-area">
        <input {...props} />
        <div className="error-view">{touched && error}</div>
      </div>
    );
  }
}

export default CardExpiryInput;
